import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import {useState} from "react";
import {putRequest} from "../../../httpClient";
import {useAuth} from "oidc-react";
import {isAuthenticated} from "../../utils/security-utils";

const EditVerseModal = ({ open, setOpen, song, verse, reload, searchClient }) => {

    const handleClose = () => {
        setOpen(false);
    };

    const [verseText, setVerseText] = useState('');

    const auth = useAuth();

    const update = () => {
        if (verseText === '') {
            return;
        }

        if (!isAuthenticated(auth)) {
            return;
        }

        let filteredVerses = [...song.verses.filter(v => v.id !== verse.id)];
        let currentVerseToBeUpdated = {
            ...verse,
            verseText: verseText
        }

        let updatedVerses = [...filteredVerses, currentVerseToBeUpdated];
        console.log(updatedVerses)


        const songRequest = {
            authors: song.authors,
            choruses: song.choruses,
            verses: updatedVerses,
            yearOfRelease: song.yearOfRelease,
            title: song.title,
            id: song.id,
            objectID: song.objectID,
        }

        console.log(songRequest);

        putRequest(`/v1/song/${song.id}`, auth?.userData?.access_token, JSON.stringify(songRequest))
            .then(resp => {
                if (resp.ok) {
                    searchClient.clearCache();
                    handleClose();
                    return;
                }
                throw resp;
            })
            .catch(err => console.log(err))
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{`Update verse ${verse.verseNumber} for ${song.title}`}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Update a verse text and save it. This can be used when a wrong text has been identified.
                    </DialogContentText>

                    <TextField
                        disabled
                        id="outlined-disabled"
                        label="current"
                        fullWidth
                        margin={"dense"}
                        variant={"standard"}
                        multiline
                        defaultValue={verse.verseText}
                    />

                    <TextField
                        autoFocus
                        margin="dense"
                        id="verse-text"
                        label="verse"
                        type="text"
                        fullWidth
                        variant="standard"
                        multiline
                        onChange={e => setVerseText(e.target.value)}
                    />

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={update}>Update</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default EditVerseModal;
